import PropTypes from 'prop-types';
import { useForm, useWatch } from 'react-hook-form';
import FormRow from '@/components/core/form/FormRow';
import { useNodeById } from '@/stores/analysisStore';
import { useEffect } from 'react';
import Select from '@/components/core/form/Select';
import { FormProvider } from 'react-hook-form';
import debounce from 'debounce';
import LevelizationForm from '@/components/core/LevelizationForm';
import { ModuleSelect } from '@/components/core/form/ModuleSelect';
const levelizeOptions = [
  { value: 'false', label: 'Total' },
  { value: 'true', label: 'Per Functional Unit' },
];

const MCPlotForm = ({ defaultValues, onSubmit }) => {
  const { levelized_cost } = defaultValues;
  const methods = useForm({ defaultValues });
  const { handleSubmit, control, reset } = methods;

  const [nodeId, levelize, levelizeBy] = useWatch({
    control,
    name: ['nodeId', 'levelize', 'levelizeBy'],
    defaultValue: defaultValues,
  });

  const node = useNodeById(nodeId);
  const debouncedSave = debounce(() => handleSubmit(onSubmit)(), 10);

  useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);

  return (
    <div className="group node">
      <FormProvider {...methods}>
        <form onChange={debouncedSave}>
          <div className="mt-2 grid grid-cols-6 gap-2">
            <div>
              <ModuleSelect />
            </div>
            <div>
              <FormRow label="Values" name="levelize">
                <Select className="w-full truncate" name="levelize" options={levelizeOptions} />
              </FormRow>
            </div>
            <div>
              <LevelizationForm node={node} levelize={levelize} showUnit={false} levelizeBy={levelizeBy} />
            </div>
            {levelized_cost?.unit?.match(/electricity/i) && (
              <div>
                <FormRow label="Unit" name="scalar">
                  <Select
                    name="scalar"
                    options={[
                      { value: 1, label: 'kWh' },
                      { value: 1000, label: 'MWh' },
                    ]}
                    registerOptions={{ valueAsNumber: true }}
                  />
                </FormRow>
              </div>
            )}
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

MCPlotForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default MCPlotForm;
